// Sovereign AI Reading Digest & Executive Briefing Synthesizer
// Compiles scattered reading list items into a formatted research intelligence digest

import { estimateReadingTime } from './readingTime';

export function synthesizeReadingDigest(items = []) {
  const timestamp = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  if (!items || items.length === 0) {
    return `# 📰 Sovereign Reading Digest — ${timestamp}\n\n*No unread articles in the queue. Add bookmarks to your reading list to synthesize a briefing.*`;
  }

  // Calculate total reading duration
  let totalMinutes = 0;
  items.forEach(it => {
    const est = estimateReadingTime(it);
    totalMinutes += (est ? est.minutes : 3);
  });

  let md = `# 📰 Sovereign Executive Reading Digest
> Generated on **${timestamp}** from [MeMark](https://app.memark.me/)
> Total Reading Commitment: **~${totalMinutes} minutes** (${items.length} items queued)

---

## 🎯 Executive Reading Agenda

`;

  items.forEach((it, idx) => {
    const est = estimateReadingTime(it);
    const domain = (it.url || '').replace(/^https?:\/\//, '').split('/')[0] || 'Web';
    const tags = (it.tags || []).map(t => t.startsWith('#') ? t : `#${t}`).join(' ') || '#reading';
    const note = it.notes || it.description || 'No notes attached.';

    md += `### ${idx + 1}. [${it.title || 'Untitled'}](${it.url || '#'})
- **Source**: \`${domain}\` • **Est. Time**: \`${est?.label || '~3 min read'}\` • **Tags**: ${tags}
> ${note}

- [ ] Complete reading & extract key insights
- [ ] Archive or move to reference folder

---

`;
  });

  md += `\n## 💡 Key Synthesized Takeaways & Action Items
- [ ] Review documentation and developer tooling updates
- [ ] Share critical research briefs with team or collaborators
- [ ] Export notes to Obsidian vault for long-term knowledge compounding

---
*Generated by MeMark Sovereign Reading Engine v2.4 • Zero External Leakage*
`;

  return md;
}
